var _excluded = ["transform"],
  _excluded2 = ["id", "autoScroll", "announcements", "children", "sensors", "collisionDetection", "layoutMeasuring", "modifiers", "screenReaderInstructions"],
  _excluded3 = ["children", "transform"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { createContext, useContext, useRef, useEffect, useState, useMemo, useCallback, memo, useReducer } from 'react';
import { createPortal } from 'react-dom';
import { canUseDOM, add, useUniqueId, useInterval, useLazyMemo, useIsomorphicLayoutEffect, subtract, useNodeRef, CSS } from '@dnd-kit/utilities';
import { useAnnouncement, HiddenText, LiveRegion } from '@dnd-kit/accessibility';
var screenReaderInstructions = {
  draggable: "\n    To pick up a draggable item, press the space bar.\n    While dragging, use the arrow keys to move the item.\n    Press space again to drop the item in its new position, or press escape to cancel.\n  "
};
var defaultAnnouncements = {
  onDragStart: function onDragStart(id) {
    return "Picked up draggable item ".concat(id, ".");
  },
  onDragOver: function onDragOver(id, overId) {
    if (overId) {
      return "Draggable item ".concat(id, " was moved over droppable area ").concat(overId, ".");
    }
    return "Draggable item ".concat(id, " is no longer over a droppable area.");
  },
  onDragEnd: function onDragEnd(id, overId) {
    if (overId) {
      return "Draggable item ".concat(id, " was dropped over droppable area ").concat(overId);
    }
    return "Draggable item ".concat(id, " was dropped.");
  },
  onDragCancel: function onDragCancel(id) {
    return "Dragging was cancelled. Draggable item ".concat(id, " was dropped.");
  }
};
var Action;
(function (Action) {
  Action["DragStart"] = "dragStart";
  Action["DragMove"] = "dragMove";
  Action["DragEnd"] = "dragEnd";
  Action["DragCancel"] = "dragCancel";
  Action["DragOver"] = "dragOver";
  Action["RegisterDroppable"] = "registerDroppable";
  Action["SetDroppableDisabled"] = "setDroppableDisabled";
  Action["UnregisterDroppable"] = "unregisterDroppable";
})(Action || (Action = {}));
var getMaxValueIndex = function getMaxValueIndex(array) {
  return getValueIndex(array, function (value, tracked) {
    return value > tracked;
  });
};
var getMinValueIndex = function getMinValueIndex(array) {
  return getValueIndex(array, function (value, tracked) {
    return value < tracked;
  });
};
/**
 * Returns the index of the smallest number in an array of numbers
 */

function getValueIndex(array, comparator) {
  if (array.length === 0) {
    return -1;
  }
  var tracked = array[0];
  var index = 0;
  for (var i = 1; i < array.length; i++) {
    if (comparator(array[i], tracked)) {
      index = i;
      tracked = array[i];
    }
  }
  return index;
}
function noop() {}
function omit(id, elements) {
  var _ = elements[id],
    other = _objectWithoutProperties(elements, [id].map(_toPropertyKey));
  return other;
}
var Context = /*#__PURE__*/createContext({
  activatorEvent: null,
  active: null,
  activeNode: null,
  activeNodeRect: null,
  activeNodeClientRect: null,
  activators: [],
  ariaDescribedById: {
    draggable: ''
  },
  containerNodeRect: null,
  dispatch: noop,
  draggableNodes: {},
  droppableRects: /*#__PURE__*/new Map(),
  droppableContainers: {},
  over: null,
  overlayNode: {
    nodeRef: {
      current: null
    },
    rect: null,
    setRef: noop
  },
  scrollableAncestors: [],
  scrollableAncestorRects: [],
  recomputeLayouts: noop,
  windowRect: null,
  willRecomputeLayouts: false
});
var defaultCoordinates = /*#__PURE__*/Object.freeze({
  x: 0,
  y: 0
});

/**
 * Returns the distance between two points
 */
function distanceBetween(p1, p2) {
  return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}
function isTouchEvent(event) {
  var _window;
  return ((_window = window) == null ? void 0 : _window.TouchEvent) && event instanceof TouchEvent;
}
function isMouseEvent(event) {
  var _window;
  return ((_window = window) == null ? void 0 : _window.MouseEvent) && event instanceof MouseEvent || event.type.includes('mouse');
}

/**
 * Returns the normalized x and y coordinates for mouse and touch events.
 */

function getEventCoordinates(event) {
  if (isTouchEvent(event)) {
    if (event.touches && event.touches.length) {
      var _event$touches$ = event.touches[0],
        x = _event$touches$.clientX,
        y = _event$touches$.clientY;
      return {
        x: x,
        y: y
      };
    } else if (event.changedTouches && event.changedTouches.length) {
      var _event$changedTouches = event.changedTouches[0],
        _x = _event$changedTouches.clientX,
        _y = _event$changedTouches.clientY;
      return {
        x: _x,
        y: _y
      };
    }
  }
  if (isMouseEvent(event)) {
    return {
      x: event.clientX,
      y: event.clientY
    };
  }
  return {
    x: 0,
    y: 0
  };
}
function getRelativeTransformOrigin(event, rect) {
  if (event instanceof KeyboardEvent) {
    return '0 0';
  }
  var eventCoordinates = getEventCoordinates(event);
  var transformOrigin = {
    x: (eventCoordinates.x - rect.left) / rect.width * 100,
    y: (eventCoordinates.y - rect.top) / rect.height * 100
  };
  return "".concat(transformOrigin.x, "% ").concat(transformOrigin.y, "%");
}

/**
 * Returns the coordinates of the center of a given ClientRect
 */

function centerOfRectangle(rect) {
  var left = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : rect.offsetLeft;
  var top = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : rect.offsetTop;
  return {
    x: left + rect.width * 0.5,
    y: top + rect.height * 0.5
  };
}
/**
 * Returns the closest rectangle from an array of rectangles to the center of a given
 * rectangle.
 */

var closestCenter = function closestCenter(rects, rect) {
  var centerRect = centerOfRectangle(rect, rect.left, rect.top);
  var distances = rects.map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      _ = _ref3[0],
      rect = _ref3[1];
    return distanceBetween(centerOfRectangle(rect), centerRect);
  });
  var minValueIndex = getMinValueIndex(distances);
  return rects[minValueIndex] ? rects[minValueIndex][0] : null;
};
function adjustScale(transform, rect1, rect2) {
  return _objectSpread(_objectSpread({}, transform), {}, {
    scaleX: rect1 && rect2 ? rect1.width / rect2.width : 1,
    scaleY: rect1 && rect2 ? rect1.height / rect2.height : 1
  });
}
function getRectDelta(rect1, rect2) {
  return rect1 && rect2 ? {
    x: rect1.left - rect2.left,
    y: rect1.top - rect2.top
  } : defaultCoordinates;
}
function createRectAdjustmentFn(modifier) {
  return function adjustViewRect(viewRect) {
    for (var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      adjustments[_key - 1] = arguments[_key];
    }
    return adjustments.reduce(function (acc, adjustment) {
      return _objectSpread(_objectSpread({}, acc), {}, {
        top: acc.top + modifier * adjustment.y,
        bottom: acc.bottom + modifier * adjustment.y,
        left: acc.left + modifier * adjustment.x,
        right: acc.right + modifier * adjustment.x,
        offsetLeft: acc.offsetLeft + modifier * adjustment.x,
        offsetTop: acc.offsetTop + modifier * adjustment.y
      });
    }, _objectSpread({}, viewRect));
  };
}
var getAdjustedRect = /*#__PURE__*/createRectAdjustmentFn(1);
function isScrollable(node) {
  var computedStyle = window.getComputedStyle(node);
  var overflowRegex = /(auto|scroll|overlay)/;
  var properties = ['overflow', 'overflowX', 'overflowY'];
  return properties.find(function (property) {
    var value = computedStyle[property];
    return typeof value === 'string' ? overflowRegex.test(value) : false;
  }) != null;
}
function getScrollableAncestors(element) {
  var scrollParents = [];
  function findScrollableAncestors(node) {
    if (!node) {
      return scrollParents;
    }
    if (node instanceof Document && node.scrollingElement != null) {
      scrollParents.push(node.scrollingElement);
      return scrollParents;
    }
    if (!(node instanceof HTMLElement) || node instanceof SVGElement) {
      return scrollParents;
    }
    if (isScrollable(node)) {
      scrollParents.push(node);
    }
    return findScrollableAncestors(node.parentNode);
  }
  return element ? findScrollableAncestors(element.parentNode) : scrollParents;
}
function getScrollableElement(element) {
  if (!canUseDOM) {
    return null;
  }
  if (element === document.scrollingElement || element instanceof Document) {
    return window;
  }
  if (element instanceof HTMLElement) {
    return element;
  }
  return null;
}
function getScrollCoordinates(element) {
  if (element instanceof Window) {
    return {
      x: element.scrollX,
      y: element.scrollY
    };
  }
  return {
    x: element.scrollLeft,
    y: element.scrollTop
  };
}
var Direction;
(function (Direction) {
  Direction[Direction["Forward"] = 1] = "Forward";
  Direction[Direction["Backward"] = -1] = "Backward";
})(Direction || (Direction = {}));
function getScrollPosition(scrollingContainer) {
  var minScroll = {
    x: 0,
    y: 0
  };
  var maxScroll = {
    x: scrollingContainer.scrollWidth - scrollingContainer.clientWidth,
    y: scrollingContainer.scrollHeight - scrollingContainer.clientHeight
  };
  var isTop = scrollingContainer.scrollTop <= minScroll.y;
  var isLeft = scrollingContainer.scrollLeft <= minScroll.x;
  var isBottom = scrollingContainer.scrollTop >= maxScroll.y;
  var isRight = scrollingContainer.scrollLeft >= maxScroll.x;
  return {
    isTop: isTop,
    isLeft: isLeft,
    isBottom: isBottom,
    isRight: isRight,
    maxScroll: maxScroll,
    minScroll: minScroll
  };
}
function isDocumentScrollingElement(element) {
  if (!canUseDOM || !element) {
    return false;
  }
  return element === document.scrollingElement;
}
var defaultThreshold = {
  x: 0.2,
  y: 0.2
};
function getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, _ref4) {
  var top = _ref4.top,
    left = _ref4.left,
    right = _ref4.right,
    bottom = _ref4.bottom;
  var acceleration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10;
  var thresholdPercentage = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : defaultThreshold;
  var clientHeight = scrollContainer.clientHeight,
    clientWidth = scrollContainer.clientWidth;
  var finalScrollContainerRect = isDocumentScrollingElement(scrollContainer) ? {
    top: 0,
    left: 0,
    right: clientWidth,
    bottom: clientHeight,
    width: clientWidth,
    height: clientHeight
  } : scrollContainerRect;
  var _getScrollPosition = getScrollPosition(scrollContainer),
    isTop = _getScrollPosition.isTop,
    isBottom = _getScrollPosition.isBottom,
    isLeft = _getScrollPosition.isLeft,
    isRight = _getScrollPosition.isRight;
  var direction = {
    x: 0,
    y: 0
  };
  var speed = {
    x: 0,
    y: 0
  };
  var threshold = {
    height: finalScrollContainerRect.height * thresholdPercentage.y,
    width: finalScrollContainerRect.width * thresholdPercentage.x
  };
  if (!isTop && top <= finalScrollContainerRect.top + threshold.height) {
    // Scroll Up
    direction.y = Direction.Backward;
    speed.y = acceleration * Math.abs((finalScrollContainerRect.top + threshold.height - top) / threshold.height);
  } else if (!isBottom && bottom >= finalScrollContainerRect.bottom - threshold.height) {
    // Scroll Down
    direction.y = Direction.Forward;
    speed.y = acceleration * Math.abs((finalScrollContainerRect.bottom - threshold.height - bottom) / threshold.height);
  }
  if (!isRight && right >= finalScrollContainerRect.right - threshold.width) {
    // Scroll Right
    direction.x = Direction.Forward;
    speed.x = acceleration * Math.abs((finalScrollContainerRect.right - threshold.width - right) / threshold.width);
  } else if (!isLeft && left <= finalScrollContainerRect.left + threshold.width) {
    // Scroll Left
    direction.x = Direction.Backward;
    speed.x = acceleration * Math.abs((finalScrollContainerRect.left + threshold.width - left) / threshold.width);
  }
  return {
    direction: direction,
    speed: speed
  };
}
function getScrollElementRect(element) {
  if (element === document.scrollingElement) {
    var _window2 = window,
      innerWidth = _window2.innerWidth,
      innerHeight = _window2.innerHeight;
    return {
      top: 0,
      left: 0,
      right: innerWidth,
      bottom: innerHeight,
      width: innerWidth,
      height: innerHeight
    };
  }
  var _element$getBoundingC = element.getBoundingClientRect(),
    top = _element$getBoundingC.top,
    left = _element$getBoundingC.left,
    right = _element$getBoundingC.right,
    bottom = _element$getBoundingC.bottom;
  return {
    top: top,
    left: left,
    right: right,
    bottom: bottom,
    width: element.clientWidth,
    height: element.clientHeight
  };
}
function getScrollOffsets(scrollableAncestors) {
  return scrollableAncestors.reduce(function (acc, node) {
    return add(acc, getScrollCoordinates(node));
  }, defaultCoordinates);
}
function getEdgeOffset(node, parent) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultCoordinates;
  if (!node || !(node instanceof HTMLElement)) {
    return offset;
  }
  var nodeOffset = {
    x: offset.x + node.offsetLeft,
    y: offset.y + node.offsetTop
  };
  if (node.offsetParent === parent) {
    return nodeOffset;
  }
  return getEdgeOffset(node.offsetParent, parent, nodeOffset);
}
function getElementLayout(element) {
  var width = element.offsetWidth,
    height = element.offsetHeight;
  var _getEdgeOffset = getEdgeOffset(element, null),
    offsetLeft = _getEdgeOffset.x,
    offsetTop = _getEdgeOffset.y;
  return {
    width: width,
    height: height,
    offsetTop: offsetTop,
    offsetLeft: offsetLeft
  };
}
function getBoundingClientRect(element) {
  if (element instanceof Window) {
    var _width = window.innerWidth;
    var _height = window.innerHeight;
    return {
      top: 0,
      left: 0,
      right: _width,
      bottom: _height,
      width: _width,
      height: _height,
      offsetTop: 0,
      offsetLeft: 0
    };
  }
  var _getElementLayout = getElementLayout(element),
    offsetTop = _getElementLayout.offsetTop,
    offsetLeft = _getElementLayout.offsetLeft;
  var _element$getBoundingC2 = element.getBoundingClientRect(),
    width = _element$getBoundingC2.width,
    height = _element$getBoundingC2.height,
    top = _element$getBoundingC2.top,
    bottom = _element$getBoundingC2.bottom,
    left = _element$getBoundingC2.left,
    right = _element$getBoundingC2.right;
  return {
    width: width,
    height: height,
    top: top,
    bottom: bottom,
    right: right,
    left: left,
    offsetTop: offsetTop,
    offsetLeft: offsetLeft
  };
}
function getViewRect(element) {
  var _getElementLayout2 = getElementLayout(element),
    width = _getElementLayout2.width,
    height = _getElementLayout2.height,
    offsetTop = _getElementLayout2.offsetTop,
    offsetLeft = _getElementLayout2.offsetLeft;
  var scrollableAncestors = getScrollableAncestors(element);
  var scrollOffsets = getScrollOffsets(scrollableAncestors);
  var top = offsetTop - scrollOffsets.y;
  var left = offsetLeft - scrollOffsets.x;
  return {
    width: width,
    height: height,
    top: top,
    bottom: top + height,
    right: left + width,
    left: left,
    offsetTop: offsetTop,
    offsetLeft: offsetLeft
  };
}
function isViewRect(entry) {
  return 'top' in entry;
}

/**
 * Returns the coordinates of the corners of a given rectangle:
 * [TopLeft {x, y}, TopRight {x, y}, BottomLeft {x, y}, BottomRight {x, y}]
 */

function cornersOfRectangle(rect) {
  var left = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : rect.offsetLeft;
  var top = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : rect.offsetTop;
  return [{
    x: left,
    y: top
  }, {
    x: left + rect.width,
    y: top
  }, {
    x: left,
    y: top + rect.height
  }, {
    x: left + rect.width,
    y: top + rect.height
  }];
}
/**
 * Returns the closest rectangle from an array of rectangles to the corners of
 * another rectangle.
 */

var closestCorners = function closestCorners(entries, target) {
  var corners = cornersOfRectangle(target, target.left, target.top);
  var distances = entries.map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      _ = _ref6[0],
      entry = _ref6[1];
    var entryCorners = cornersOfRectangle(entry, isViewRect(entry) ? entry.left : undefined, isViewRect(entry) ? entry.top : undefined);
    var distances = corners.reduce(function (accumulator, corner, index) {
      return accumulator + distanceBetween(entryCorners[index], corner);
    }, 0);
    return Number((distances / 4).toFixed(4));
  });
  var minValueIndex = getMinValueIndex(distances);
  return entries[minValueIndex] ? entries[minValueIndex][0] : null;
};

/**
 * Returns the intersecting rectangle area between two rectangles
 */

function getIntersectionRatio(entry, target) {
  var top = Math.max(target.top, entry.offsetTop);
  var left = Math.max(target.left, entry.offsetLeft);
  var right = Math.min(target.left + target.width, entry.offsetLeft + entry.width);
  var bottom = Math.min(target.top + target.height, entry.offsetTop + entry.height);
  var width = right - left;
  var height = bottom - top;
  if (left < right && top < bottom) {
    var targetArea = target.width * target.height;
    var entryArea = entry.width * entry.height;
    var intersectionArea = width * height;
    var intersectionRatio = intersectionArea / (targetArea + entryArea - intersectionArea);
    return Number(intersectionRatio.toFixed(4));
  } // Rectangles do not overlap, or overlap has an area of zero (edge/corner overlap)

  return 0;
}
/**
 * Returns the rectangle that has the greatest intersection area with a given
 * rectangle in an array of rectangles.
 */

var rectIntersection = function rectIntersection(entries, target) {
  var intersections = entries.map(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
      _ = _ref8[0],
      entry = _ref8[1];
    return getIntersectionRatio(entry, target);
  });
  var maxValueIndex = getMaxValueIndex(intersections);
  if (intersections[maxValueIndex] <= 0) {
    return null;
  }
  return entries[maxValueIndex] ? entries[maxValueIndex][0] : null;
};
function getOwnerDocument(target) {
  return target instanceof HTMLElement ? target.ownerDocument : document;
}
function getWindow(target) {
  var _getOwnerDocument$def;
  return (_getOwnerDocument$def = getOwnerDocument(target).defaultView) != null ? _getOwnerDocument$def : window;
}
function getInitialState() {
  return {
    draggable: {
      active: null,
      initialCoordinates: {
        x: 0,
        y: 0
      },
      nodes: {},
      translate: {
        x: 0,
        y: 0
      }
    },
    droppable: {
      containers: {}
    }
  };
}
function reducer(state, action) {
  switch (action.type) {
    case Action.DragStart:
      return _objectSpread(_objectSpread({}, state), {}, {
        draggable: _objectSpread(_objectSpread({}, state.draggable), {}, {
          initialCoordinates: action.initialCoordinates,
          active: action.active
        })
      });
    case Action.DragMove:
      if (!state.draggable.active) {
        return state;
      }
      return _objectSpread(_objectSpread({}, state), {}, {
        draggable: _objectSpread(_objectSpread({}, state.draggable), {}, {
          translate: {
            x: action.coordinates.x - state.draggable.initialCoordinates.x,
            y: action.coordinates.y - state.draggable.initialCoordinates.y
          }
        })
      });
    case Action.DragEnd:
    case Action.DragCancel:
      return _objectSpread(_objectSpread({}, state), {}, {
        draggable: _objectSpread(_objectSpread({}, state.draggable), {}, {
          active: null,
          initialCoordinates: {
            x: 0,
            y: 0
          },
          translate: {
            x: 0,
            y: 0
          }
        })
      });
    case Action.RegisterDroppable:
      {
        var element = action.element;
        var id = element.id;
        return _objectSpread(_objectSpread({}, state), {}, {
          droppable: _objectSpread(_objectSpread({}, state.droppable), {}, {
            containers: _objectSpread(_objectSpread({}, state.droppable.containers), {}, _defineProperty({}, id, element))
          })
        });
      }
    case Action.SetDroppableDisabled:
      {
        var _id = action.id,
          disabled = action.disabled;
        var _element = state.droppable.containers[_id];
        if (!_element) {
          return state;
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          droppable: _objectSpread(_objectSpread({}, state.droppable), {}, {
            containers: _objectSpread(_objectSpread({}, state.droppable.containers), {}, _defineProperty({}, _id, _objectSpread(_objectSpread({}, _element), {}, {
              disabled: disabled
            })))
          })
        });
      }
    case Action.UnregisterDroppable:
      {
        var _id2 = action.id;
        return _objectSpread(_objectSpread({}, state), {}, {
          droppable: _objectSpread(_objectSpread({}, state.droppable), {}, {
            containers: omit(_id2, state.droppable.containers)
          })
        });
      }
    default:
      {
        return state;
      }
  }
}
var DndMonitorContext = /*#__PURE__*/createContext({
  type: null,
  event: null
});
function useDndMonitor(_ref9) {
  var onDragStart = _ref9.onDragStart,
    onDragMove = _ref9.onDragMove,
    onDragOver = _ref9.onDragOver,
    onDragEnd = _ref9.onDragEnd,
    onDragCancel = _ref9.onDragCancel;
  var monitorState = useContext(DndMonitorContext);
  var previousMonitorState = useRef(monitorState);
  useEffect(function () {
    if (monitorState !== previousMonitorState.current) {
      var type = monitorState.type,
        event = monitorState.event;
      switch (type) {
        case Action.DragStart:
          onDragStart == null ? void 0 : onDragStart(event);
          break;
        case Action.DragMove:
          onDragMove == null ? void 0 : onDragMove(event);
          break;
        case Action.DragOver:
          onDragOver == null ? void 0 : onDragOver(event);
          break;
        case Action.DragCancel:
          onDragCancel == null ? void 0 : onDragCancel(event);
          break;
        case Action.DragEnd:
          onDragEnd == null ? void 0 : onDragEnd(event);
          break;
      }
      previousMonitorState.current = monitorState;
    }
  }, [monitorState, onDragStart, onDragMove, onDragOver, onDragEnd, onDragCancel]);
}
function Accessibility(_ref10) {
  var _ref10$announcements = _ref10.announcements,
    announcements = _ref10$announcements === void 0 ? defaultAnnouncements : _ref10$announcements,
    hiddenTextDescribedById = _ref10.hiddenTextDescribedById,
    screenReaderInstructions = _ref10.screenReaderInstructions;
  var _useAnnouncement = useAnnouncement(),
    announce = _useAnnouncement.announce,
    announcement = _useAnnouncement.announcement;
  var liveRegionId = useUniqueId("DndLiveRegion");
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    mounted = _useState2[0],
    setMounted = _useState2[1];
  useEffect(function () {
    setMounted(true);
  }, []);
  useDndMonitor(useMemo(function () {
    return {
      onDragStart: function onDragStart(_ref11) {
        var active = _ref11.active;
        announce(announcements.onDragStart(active.id));
      },
      onDragMove: function onDragMove(_ref12) {
        var active = _ref12.active,
          over = _ref12.over;
        if (announcements.onDragMove) {
          announce(announcements.onDragMove(active.id, over == null ? void 0 : over.id));
        }
      },
      onDragOver: function onDragOver(_ref13) {
        var active = _ref13.active,
          over = _ref13.over;
        announce(announcements.onDragOver(active.id, over == null ? void 0 : over.id));
      },
      onDragEnd: function onDragEnd(_ref14) {
        var active = _ref14.active,
          over = _ref14.over;
        announce(announcements.onDragEnd(active.id, over == null ? void 0 : over.id));
      },
      onDragCancel: function onDragCancel(_ref15) {
        var active = _ref15.active;
        announce(announcements.onDragCancel(active.id));
      }
    };
  }, [announce, announcements]));
  return mounted ? /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HiddenText, {
    id: hiddenTextDescribedById,
    value: screenReaderInstructions.draggable
  }), /*#__PURE__*/React.createElement(LiveRegion, {
    id: liveRegionId,
    announcement: announcement
  })), document.body) : null;
}
var AutoScrollActivator;
(function (AutoScrollActivator) {
  AutoScrollActivator[AutoScrollActivator["Pointer"] = 0] = "Pointer";
  AutoScrollActivator[AutoScrollActivator["DraggableRect"] = 1] = "DraggableRect";
})(AutoScrollActivator || (AutoScrollActivator = {}));
var TraversalOrder;
(function (TraversalOrder) {
  TraversalOrder[TraversalOrder["TreeOrder"] = 0] = "TreeOrder";
  TraversalOrder[TraversalOrder["ReversedTreeOrder"] = 1] = "ReversedTreeOrder";
})(TraversalOrder || (TraversalOrder = {}));
function useAutoScroller(_ref16) {
  var acceleration = _ref16.acceleration,
    _ref16$activator = _ref16.activator,
    activator = _ref16$activator === void 0 ? AutoScrollActivator.Pointer : _ref16$activator,
    canScroll = _ref16.canScroll,
    draggingRect = _ref16.draggingRect,
    enabled = _ref16.enabled,
    _ref16$interval = _ref16.interval,
    interval = _ref16$interval === void 0 ? 5 : _ref16$interval,
    _ref16$order = _ref16.order,
    order = _ref16$order === void 0 ? TraversalOrder.TreeOrder : _ref16$order,
    pointerCoordinates = _ref16.pointerCoordinates,
    scrollableAncestors = _ref16.scrollableAncestors,
    scrollableAncestorRects = _ref16.scrollableAncestorRects,
    threshold = _ref16.threshold;
  var _useInterval = useInterval(),
    _useInterval2 = _slicedToArray(_useInterval, 2),
    setAutoScrollInterval = _useInterval2[0],
    clearAutoScrollInterval = _useInterval2[1];
  var scrollSpeed = useRef({
    x: 1,
    y: 1
  });
  var rect = useMemo(function () {
    switch (activator) {
      case AutoScrollActivator.Pointer:
        return pointerCoordinates ? {
          top: pointerCoordinates.y,
          bottom: pointerCoordinates.y,
          left: pointerCoordinates.x,
          right: pointerCoordinates.x
        } : null;
      case AutoScrollActivator.DraggableRect:
        return draggingRect;
    }
    return null;
  }, [activator, draggingRect, pointerCoordinates]);
  var scrollDirection = useRef(defaultCoordinates);
  var scrollContainerRef = useRef(null);
  var autoScroll = useCallback(function () {
    var scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) {
      return;
    }
    var scrollLeft = scrollSpeed.current.x * scrollDirection.current.x;
    var scrollTop = scrollSpeed.current.y * scrollDirection.current.y;
    scrollContainer.scrollBy(scrollLeft, scrollTop);
  }, []);
  var sortedScrollableAncestors = useMemo(function () {
    return order === TraversalOrder.TreeOrder ? _toConsumableArray(scrollableAncestors).reverse() : scrollableAncestors;
  }, [order, scrollableAncestors]);
  useEffect(function () {
    if (!enabled || !scrollableAncestors.length || !rect) {
      clearAutoScrollInterval();
      return;
    }
    var _iterator = _createForOfIteratorHelper(sortedScrollableAncestors),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var scrollContainer = _step.value;
        if ((canScroll == null ? void 0 : canScroll(scrollContainer)) === false) {
          continue;
        }
        var index = scrollableAncestors.indexOf(scrollContainer);
        var scrolllContainerRect = scrollableAncestorRects[index];
        if (!scrolllContainerRect) {
          continue;
        }
        var _getScrollDirectionAn = getScrollDirectionAndSpeed(scrollContainer, scrolllContainerRect, rect, acceleration, threshold),
          direction = _getScrollDirectionAn.direction,
          speed = _getScrollDirectionAn.speed;
        if (speed.x > 0 || speed.y > 0) {
          clearAutoScrollInterval();
          scrollContainerRef.current = scrollContainer;
          setAutoScrollInterval(autoScroll, interval);
          scrollSpeed.current = speed;
          scrollDirection.current = direction;
          return;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    scrollSpeed.current = {
      x: 0,
      y: 0
    };
    scrollDirection.current = {
      x: 0,
      y: 0
    };
    clearAutoScrollInterval();
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [acceleration, autoScroll, canScroll, clearAutoScrollInterval, enabled, interval,
  // eslint-disable-next-line react-hooks/exhaustive-deps
  JSON.stringify(rect), setAutoScrollInterval, scrollableAncestors, sortedScrollableAncestors, scrollableAncestorRects,
  // eslint-disable-next-line react-hooks/exhaustive-deps
  JSON.stringify(threshold)]);
}
function useCachedNode(draggableNodes, id) {
  var draggableNode = id !== null ? draggableNodes[id] : undefined;
  var node = draggableNode ? draggableNode.node.current : null;
  return useLazyMemo(function (cachedNode) {
    var _ref;
    if (id === null) {
      return null;
    } // In some cases, the draggable node can unmount while dragging
    // This is the case for virtualized lists. In those situations,
    // we fall back to the last known value for that node.

    return (_ref = node != null ? node : cachedNode) != null ? _ref : null;
  }, [node, id]);
}
function useCombineActivators(sensors, getSyntheticHandler) {
  return useMemo(function () {
    return sensors.reduce(function (accumulator, sensor) {
      var Sensor = sensor.sensor;
      var sensorActivators = Sensor.activators.map(function (activator) {
        return {
          eventName: activator.eventName,
          handler: getSyntheticHandler(activator.handler, sensor)
        };
      });
      return [].concat(_toConsumableArray(accumulator), _toConsumableArray(sensorActivators));
    }, []);
  }, [sensors, getSyntheticHandler]);
}
function useData(data) {
  var dataRef = useRef(data);
  useIsomorphicLayoutEffect(function () {
    if (dataRef.current !== data) {
      dataRef.current = data;
    }
  }, [data]);
  return dataRef;
}
var LayoutMeasuringStrategy;
(function (LayoutMeasuringStrategy) {
  LayoutMeasuringStrategy[LayoutMeasuringStrategy["Always"] = 0] = "Always";
  LayoutMeasuringStrategy[LayoutMeasuringStrategy["BeforeDragging"] = 1] = "BeforeDragging";
  LayoutMeasuringStrategy[LayoutMeasuringStrategy["WhileDragging"] = 2] = "WhileDragging";
})(LayoutMeasuringStrategy || (LayoutMeasuringStrategy = {}));
var LayoutMeasuringFrequency;
(function (LayoutMeasuringFrequency) {
  LayoutMeasuringFrequency["Optimized"] = "optimized";
})(LayoutMeasuringFrequency || (LayoutMeasuringFrequency = {}));
var defaultValue = /*#__PURE__*/new Map();
function useLayoutMeasuring(containers, _ref17) {
  var dragging = _ref17.dragging,
    dependencies = _ref17.dependencies,
    config = _ref17.config;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    willRecomputeLayouts = _useState4[0],
    setWillRecomputeLayouts = _useState4[1];
  var _getLayoutMeasuring = getLayoutMeasuring(config),
    frequency = _getLayoutMeasuring.frequency,
    strategy = _getLayoutMeasuring.strategy;
  var containersRef = useRef(containers);
  var recomputeLayouts = useCallback(function () {
    return setWillRecomputeLayouts(true);
  }, []);
  var recomputeLayoutsTimeoutId = useRef(null);
  var disabled = isDisabled();
  var layoutRectMap = useLazyMemo(function (previousValue) {
    if (disabled && !dragging) {
      return defaultValue;
    }
    if (!previousValue || previousValue === defaultValue || containersRef.current !== containers || willRecomputeLayouts) {
      for (var _i = 0, _Object$values = Object.values(containers); _i < _Object$values.length; _i++) {
        var container = _Object$values[_i];
        if (!container) {
          continue;
        }
        container.rect.current = container.node.current ? getElementLayout(container.node.current) : null;
      }
      return createLayoutRectMap(containers);
    }
    return previousValue;
  }, [containers, dragging, disabled, willRecomputeLayouts]);
  useEffect(function () {
    containersRef.current = containers;
  }, [containers]);
  useEffect(function () {
    if (willRecomputeLayouts) {
      setWillRecomputeLayouts(false);
    }
  }, [willRecomputeLayouts]);
  useEffect(function recompute() {
    if (disabled) {
      return;
    }
    requestAnimationFrame(recomputeLayouts);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [dragging, disabled]);
  useEffect(function forceRecomputeLayouts() {
    if (disabled || typeof frequency !== 'number' || recomputeLayoutsTimeoutId.current !== null) {
      return;
    }
    recomputeLayoutsTimeoutId.current = setTimeout(function () {
      recomputeLayouts();
      recomputeLayoutsTimeoutId.current = null;
    }, frequency);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [frequency, disabled, recomputeLayouts].concat(_toConsumableArray(dependencies)));
  return {
    layoutRectMap: layoutRectMap,
    recomputeLayouts: recomputeLayouts,
    willRecomputeLayouts: willRecomputeLayouts
  };
  function isDisabled() {
    switch (strategy) {
      case LayoutMeasuringStrategy.Always:
        return false;
      case LayoutMeasuringStrategy.BeforeDragging:
        return dragging;
      default:
        return !dragging;
    }
  }
}
function createLayoutRectMap(containers) {
  var layoutRectMap = new Map();
  if (containers) {
    for (var _i2 = 0, _Object$values2 = Object.values(containers); _i2 < _Object$values2.length; _i2++) {
      var container = _Object$values2[_i2];
      if (!container) {
        continue;
      }
      var id = container.id,
        rect = container.rect,
        disabled = container.disabled;
      if (disabled || rect.current == null) {
        continue;
      }
      layoutRectMap.set(id, rect.current);
    }
  }
  return layoutRectMap;
}
var defaultLayoutMeasuring = {
  strategy: LayoutMeasuringStrategy.WhileDragging,
  frequency: LayoutMeasuringFrequency.Optimized
};
function getLayoutMeasuring(layoutMeasuring) {
  return layoutMeasuring ? _objectSpread(_objectSpread({}, defaultLayoutMeasuring), layoutMeasuring) : defaultLayoutMeasuring;
}
function useScrollOffsets(elements) {
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    scrollCoordinates = _useState6[0],
    setScrollCoordinates = _useState6[1];
  var prevElements = useRef(elements); // To-do: Throttle the handleScroll callback

  var handleScroll = useCallback(function (event) {
    var scrollingElement = getScrollableElement(event.target);
    if (!scrollingElement) {
      return;
    }
    setScrollCoordinates(function (scrollCoordinates) {
      if (!scrollCoordinates) {
        return null;
      }
      scrollCoordinates.set(scrollingElement, getScrollCoordinates(scrollingElement));
      return new Map(scrollCoordinates);
    });
  }, []);
  useEffect(function () {
    var previousElements = prevElements.current;
    if (elements !== previousElements) {
      cleanup(previousElements);
      var entries = elements.map(function (element) {
        var scrollableElement = getScrollableElement(element);
        if (scrollableElement) {
          scrollableElement.addEventListener('scroll', handleScroll, {
            passive: true
          });
          return [scrollableElement, getScrollCoordinates(scrollableElement)];
        }
        return null;
      }).filter(function (entry) {
        return entry != null;
      });
      setScrollCoordinates(entries.length ? new Map(entries) : null);
      prevElements.current = elements;
    }
    return function () {
      cleanup(elements);
      cleanup(previousElements);
    };
    function cleanup(elements) {
      elements.forEach(function (element) {
        var scrollableElement = getScrollableElement(element);
        scrollableElement == null ? void 0 : scrollableElement.removeEventListener('scroll', handleScroll);
      });
    }
  }, [handleScroll, elements]);
  return useMemo(function () {
    if (elements.length) {
      return scrollCoordinates ? Array.from(scrollCoordinates.values()).reduce(function (acc, coordinates) {
        return add(acc, coordinates);
      }, defaultCoordinates) : getScrollOffsets(elements);
    }
    return defaultCoordinates;
  }, [elements, scrollCoordinates]);
}
var defaultValue$1 = [];
function useScrollableAncestors(node) {
  var previousNode = useRef(node);
  var ancestors = useLazyMemo(function (previousValue) {
    if (!node) {
      return defaultValue$1;
    }
    if (previousValue && node && previousNode.current && node.parentNode === previousNode.current.parentNode) {
      return previousValue;
    }
    return getScrollableAncestors(node);
  }, [node]);
  useEffect(function () {
    previousNode.current = node;
  }, [node]);
  return ancestors;
}
function useSyntheticListeners(listeners, id) {
  return useMemo(function () {
    return listeners.reduce(function (acc, _ref18) {
      var eventName = _ref18.eventName,
        handler = _ref18.handler;
      acc[eventName] = function (event) {
        handler(event, id);
      };
      return acc;
    }, {});
  }, [listeners, id]);
}
var useClientRect = /*#__PURE__*/createUseRectFn(getBoundingClientRect);
var useClientRects = /*#__PURE__*/createUseRectsFn(getBoundingClientRect);
var useViewRect = /*#__PURE__*/createUseRectFn(getViewRect);
function createUseRectFn(getRect) {
  return function useClientRect(element, forceRecompute) {
    var previousElement = useRef(element);
    return useLazyMemo(function (previousValue) {
      if (!element) {
        return null;
      }
      if (forceRecompute || !previousValue && element || element !== previousElement.current) {
        if (element instanceof HTMLElement && element.parentNode == null) {
          return null;
        }
        return getRect(element);
      }
      return previousValue != null ? previousValue : null;
    }, [element, forceRecompute]);
  };
}
function createUseRectsFn(getRect) {
  var defaultValue = [];
  return function useRects(elements, forceRecompute) {
    var previousElements = useRef(elements);
    return useLazyMemo(function (previousValue) {
      if (!elements.length) {
        return defaultValue;
      }
      if (forceRecompute || !previousValue && elements.length || elements !== previousElements.current) {
        return elements.map(function (element) {
          return getRect(element);
        });
      }
      return previousValue != null ? previousValue : defaultValue;
    }, [elements, forceRecompute]);
  };
}
function useSensor(sensor, options) {
  return useMemo(function () {
    return {
      sensor: sensor,
      options: options != null ? options : {}
    };
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [sensor, options]);
}
function useSensors() {
  for (var _len2 = arguments.length, sensors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    sensors[_key2] = arguments[_key2];
  }
  return useMemo(function () {
    return [].concat(sensors).filter(function (sensor) {
      return sensor != null;
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [].concat(sensors));
}
var Listeners = /*#__PURE__*/function () {
  function Listeners(target) {
    _classCallCheck(this, Listeners);
    this.target = target;
    this.listeners = [];
  }
  return _createClass(Listeners, [{
    key: "add",
    value: function add(eventName, handler, options) {
      this.target.addEventListener(eventName, handler, options);
      this.listeners.push({
        eventName: eventName,
        handler: handler
      });
    }
  }, {
    key: "removeAll",
    value: function removeAll() {
      var _this = this;
      this.listeners.forEach(function (_ref19) {
        var eventName = _ref19.eventName,
          handler = _ref19.handler;
        return _this.target.removeEventListener(eventName, handler);
      });
    }
  }]);
}();
function getEventListenerTarget(element) {
  // If the `event.target` element is removed from the document events will still be targeted
  // at it, and hence won't always bubble up to the window or document anymore.
  // If there is any risk of an element being removed while it is being dragged,
  // the best practice is to attach the event listeners directly to the target.
  // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget
  return element instanceof EventTarget ? element : getOwnerDocument(element);
}
function hasExceededDistance(delta, measurement) {
  var dx = Math.abs(delta.x);
  var dy = Math.abs(delta.y);
  if (typeof measurement === 'number') {
    return Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2)) > measurement;
  }
  if ('x' in measurement && 'y' in measurement) {
    return dx > measurement.x && dy > measurement.y;
  }
  if ('x' in measurement) {
    return dx > measurement.x;
  }
  if ('y' in measurement) {
    return dy > measurement.y;
  }
  return false;
}
var KeyboardCode;
(function (KeyboardCode) {
  KeyboardCode["Space"] = "Space";
  KeyboardCode["Down"] = "ArrowDown";
  KeyboardCode["Right"] = "ArrowRight";
  KeyboardCode["Left"] = "ArrowLeft";
  KeyboardCode["Up"] = "ArrowUp";
  KeyboardCode["Esc"] = "Escape";
  KeyboardCode["Enter"] = "Enter";
})(KeyboardCode || (KeyboardCode = {}));
var defaultKeyboardCodes = {
  start: [KeyboardCode.Space, KeyboardCode.Enter],
  cancel: [KeyboardCode.Esc],
  end: [KeyboardCode.Space, KeyboardCode.Enter]
};
var defaultKeyboardCoordinateGetter = function defaultKeyboardCoordinateGetter(event, _ref20) {
  var currentCoordinates = _ref20.currentCoordinates;
  switch (event.code) {
    case KeyboardCode.Right:
      return _objectSpread(_objectSpread({}, currentCoordinates), {}, {
        x: currentCoordinates.x + 25
      });
    case KeyboardCode.Left:
      return _objectSpread(_objectSpread({}, currentCoordinates), {}, {
        x: currentCoordinates.x - 25
      });
    case KeyboardCode.Down:
      return _objectSpread(_objectSpread({}, currentCoordinates), {}, {
        y: currentCoordinates.y + 25
      });
    case KeyboardCode.Up:
      return _objectSpread(_objectSpread({}, currentCoordinates), {}, {
        y: currentCoordinates.y - 25
      });
  }
  return undefined;
};
var KeyboardSensor = /*#__PURE__*/function () {
  function KeyboardSensor(props) {
    _classCallCheck(this, KeyboardSensor);
    this.props = props;
    this.autoScrollEnabled = false;
    this.coordinates = defaultCoordinates;
    var target = props.event.target;
    this.props = props;
    this.listeners = new Listeners(getOwnerDocument(target));
    this.windowListeners = new Listeners(getWindow(target));
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.attach();
  }
  return _createClass(KeyboardSensor, [{
    key: "attach",
    value: function attach() {
      var _this2 = this;
      this.handleStart();
      setTimeout(function () {
        _this2.listeners.add('keydown', _this2.handleKeyDown);
        _this2.windowListeners.add('resize', _this2.handleCancel);
      });
    }
  }, {
    key: "handleStart",
    value: function handleStart() {
      var _this$props = this.props,
        activeNode = _this$props.activeNode,
        onStart = _this$props.onStart;
      if (!activeNode.node.current) {
        throw new Error('Active draggable node is undefined');
      }
      var activeNodeRect = getBoundingClientRect(activeNode.node.current);
      var coordinates = {
        x: activeNodeRect.left,
        y: activeNodeRect.top
      };
      this.coordinates = coordinates;
      onStart(coordinates);
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      if (event instanceof KeyboardEvent) {
        var coordinates = this.coordinates;
        var _this$props2 = this.props,
          active = _this$props2.active,
          context = _this$props2.context,
          options = _this$props2.options;
        var _options$keyboardCode = options.keyboardCodes,
          keyboardCodes = _options$keyboardCode === void 0 ? defaultKeyboardCodes : _options$keyboardCode,
          _options$coordinateGe = options.coordinateGetter,
          coordinateGetter = _options$coordinateGe === void 0 ? defaultKeyboardCoordinateGetter : _options$coordinateGe,
          _options$scrollBehavi = options.scrollBehavior,
          scrollBehavior = _options$scrollBehavi === void 0 ? 'smooth' : _options$scrollBehavi;
        var code = event.code;
        if (keyboardCodes.end.includes(code)) {
          this.handleEnd(event);
          return;
        }
        if (keyboardCodes.cancel.includes(code)) {
          this.handleCancel(event);
          return;
        }
        var newCoordinates = coordinateGetter(event, {
          active: active,
          context: context.current,
          currentCoordinates: coordinates
        });
        if (newCoordinates) {
          var scrollDelta = {
            x: 0,
            y: 0
          };
          var scrollableAncestors = context.current.scrollableAncestors;
          var _iterator2 = _createForOfIteratorHelper(scrollableAncestors),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var scrollContainer = _step2.value;
              var direction = event.code;
              var coordinatesDelta = subtract(newCoordinates, coordinates);
              var _getScrollPosition2 = getScrollPosition(scrollContainer),
                isTop = _getScrollPosition2.isTop,
                isRight = _getScrollPosition2.isRight,
                isLeft = _getScrollPosition2.isLeft,
                isBottom = _getScrollPosition2.isBottom,
                maxScroll = _getScrollPosition2.maxScroll,
                minScroll = _getScrollPosition2.minScroll;
              var scrollElementRect = getScrollElementRect(scrollContainer);
              var clampedCoordinates = {
                x: Math.min(direction === KeyboardCode.Right ? scrollElementRect.right - scrollElementRect.width / 2 : scrollElementRect.right, Math.max(direction === KeyboardCode.Right ? scrollElementRect.left : scrollElementRect.left + scrollElementRect.width / 2, newCoordinates.x)),
                y: Math.min(direction === KeyboardCode.Down ? scrollElementRect.bottom - scrollElementRect.height / 2 : scrollElementRect.bottom, Math.max(direction === KeyboardCode.Down ? scrollElementRect.top : scrollElementRect.top + scrollElementRect.height / 2, newCoordinates.y))
              };
              var canScrollX = direction === KeyboardCode.Right && !isRight || direction === KeyboardCode.Left && !isLeft;
              var canScrollY = direction === KeyboardCode.Down && !isBottom || direction === KeyboardCode.Up && !isTop;
              if (canScrollX && clampedCoordinates.x !== newCoordinates.x) {
                var canFullyScrollToNewCoordinates = direction === KeyboardCode.Right && scrollContainer.scrollLeft + coordinatesDelta.x <= maxScroll.x || direction === KeyboardCode.Left && scrollContainer.scrollLeft + coordinatesDelta.x >= minScroll.x;
                if (canFullyScrollToNewCoordinates) {
                  // We don't need to update coordinates, the scroll adjustment alone will trigger
                  // logic to auto-detect the new container we are over
                  scrollContainer.scrollBy({
                    left: coordinatesDelta.x,
                    behavior: scrollBehavior
                  });
                  return;
                }
                scrollDelta.x = direction === KeyboardCode.Right ? scrollContainer.scrollLeft - maxScroll.x : scrollContainer.scrollLeft - minScroll.x;
                scrollContainer.scrollBy({
                  left: -scrollDelta.x,
                  behavior: scrollBehavior
                });
                break;
              } else if (canScrollY && clampedCoordinates.y !== newCoordinates.y) {
                var _canFullyScrollToNewCoordinates = direction === KeyboardCode.Down && scrollContainer.scrollTop + coordinatesDelta.y <= maxScroll.y || direction === KeyboardCode.Up && scrollContainer.scrollTop + coordinatesDelta.y >= minScroll.y;
                if (_canFullyScrollToNewCoordinates) {
                  // We don't need to update coordinates, the scroll adjustment alone will trigger
                  // logic to auto-detect the new container we are over
                  scrollContainer.scrollBy({
                    top: coordinatesDelta.y,
                    behavior: scrollBehavior
                  });
                  return;
                }
                scrollDelta.y = direction === KeyboardCode.Down ? scrollContainer.scrollTop - maxScroll.y : scrollContainer.scrollTop - minScroll.y;
                scrollContainer.scrollBy({
                  top: -scrollDelta.y,
                  behavior: scrollBehavior
                });
                break;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          this.handleMove(event, add(newCoordinates, scrollDelta));
        }
      }
    }
  }, {
    key: "handleMove",
    value: function handleMove(event, coordinates) {
      var onMove = this.props.onMove;
      event.preventDefault();
      onMove(coordinates);
      this.coordinates = coordinates;
    }
  }, {
    key: "handleEnd",
    value: function handleEnd(event) {
      var onEnd = this.props.onEnd;
      event.preventDefault();
      this.detach();
      onEnd();
    }
  }, {
    key: "handleCancel",
    value: function handleCancel(event) {
      var onCancel = this.props.onCancel;
      event.preventDefault();
      this.detach();
      onCancel();
    }
  }, {
    key: "detach",
    value: function detach() {
      this.listeners.removeAll();
      this.windowListeners.removeAll();
    }
  }]);
}();
KeyboardSensor.activators = [{
  eventName: 'onKeyDown',
  handler: function handler(event, _ref21) {
    var _ref21$keyboardCodes = _ref21.keyboardCodes,
      keyboardCodes = _ref21$keyboardCodes === void 0 ? defaultKeyboardCodes : _ref21$keyboardCodes,
      onActivation = _ref21.onActivation;
    var code = event.nativeEvent.code;
    if (keyboardCodes.start.includes(code)) {
      event.preventDefault();
      onActivation == null ? void 0 : onActivation({
        event: event.nativeEvent
      });
      return true;
    }
    return false;
  }
}];
function isDistanceConstraint(constraint) {
  return Boolean(constraint && 'distance' in constraint);
}
function isDelayConstraint(constraint) {
  return Boolean(constraint && 'delay' in constraint);
}
var EventName;
(function (EventName) {
  EventName["Keydown"] = "keydown";
})(EventName || (EventName = {}));
var AbstractPointerSensor = /*#__PURE__*/function () {
  function AbstractPointerSensor(props, events) {
    var listenerTarget = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getEventListenerTarget(props.event.target);
    _classCallCheck(this, AbstractPointerSensor);
    this.props = props;
    this.events = events;
    this.autoScrollEnabled = true;
    this.activated = false;
    this.timeoutId = null;
    var event = props.event;
    this.props = props;
    this.events = events;
    this.ownerDocument = getOwnerDocument(event.target);
    this.listeners = new Listeners(listenerTarget);
    this.initialCoordinates = getEventCoordinates(event);
    this.handleStart = this.handleStart.bind(this);
    this.handleMove = this.handleMove.bind(this);
    this.handleEnd = this.handleEnd.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.attach();
  }
  return _createClass(AbstractPointerSensor, [{
    key: "attach",
    value: function attach() {
      var events = this.events,
        activationConstraint = this.props.options.activationConstraint;
      this.listeners.add(events.move.name, this.handleMove, false);
      this.listeners.add(events.end.name, this.handleEnd);
      this.ownerDocument.addEventListener(EventName.Keydown, this.handleKeydown);
      if (activationConstraint) {
        if (isDistanceConstraint(activationConstraint)) {
          return;
        }
        if (isDelayConstraint(activationConstraint)) {
          this.timeoutId = setTimeout(this.handleStart, activationConstraint.delay);
          return;
        }
      }
      this.handleStart();
    }
  }, {
    key: "detach",
    value: function detach() {
      this.listeners.removeAll();
      this.ownerDocument.removeEventListener(EventName.Keydown, this.handleKeydown);
      if (this.timeoutId !== null) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
    }
  }, {
    key: "handleStart",
    value: function handleStart() {
      var initialCoordinates = this.initialCoordinates;
      var onStart = this.props.onStart;
      if (initialCoordinates) {
        this.activated = true;
        onStart(initialCoordinates);
      }
    }
  }, {
    key: "handleMove",
    value: function handleMove(event) {
      var activated = this.activated,
        initialCoordinates = this.initialCoordinates,
        props = this.props;
      var onMove = props.onMove,
        activationConstraint = props.options.activationConstraint;
      if (!initialCoordinates) {
        return;
      }
      var coordinates = getEventCoordinates(event);
      var delta = subtract(initialCoordinates, coordinates);
      if (!activated && activationConstraint) {
        // Constraint validation
        if (isDelayConstraint(activationConstraint)) {
          if (hasExceededDistance(delta, activationConstraint.tolerance)) {
            return this.handleCancel();
          }
          return;
        }
        if (isDistanceConstraint(activationConstraint)) {
          if (hasExceededDistance(delta, activationConstraint.distance)) {
            return this.handleStart();
          }
          return;
        }
      }
      if (event.cancelable) {
        event.preventDefault();
      }
      onMove(coordinates);
    }
  }, {
    key: "handleEnd",
    value: function handleEnd() {
      var onEnd = this.props.onEnd;
      this.detach();
      onEnd();
    }
  }, {
    key: "handleCancel",
    value: function handleCancel() {
      var onCancel = this.props.onCancel;
      this.detach();
      onCancel();
    }
  }, {
    key: "handleKeydown",
    value: function handleKeydown(event) {
      if (event.code === KeyboardCode.Esc) {
        this.handleCancel();
      }
    }
  }]);
}();
var events = {
  move: {
    name: 'pointermove'
  },
  end: {
    name: 'pointerup'
  }
};
var PointerSensor = /*#__PURE__*/function (_AbstractPointerSenso) {
  function PointerSensor(props) {
    _classCallCheck(this, PointerSensor);
    var event = props.event; // Pointer events stop firing if the target is unmounted while dragging
    // Therefore we attach listeners to the owner document instead

    var listenerTarget = getOwnerDocument(event.target);
    return _callSuper(this, PointerSensor, [props, events, listenerTarget]);
  }
  _inherits(PointerSensor, _AbstractPointerSenso);
  return _createClass(PointerSensor);
}(AbstractPointerSensor);
PointerSensor.activators = [{
  eventName: 'onPointerDown',
  handler: function handler(_ref22, _ref23) {
    var event = _ref22.nativeEvent;
    var onActivation = _ref23.onActivation;
    if (!event.isPrimary || event.button !== 0) {
      return false;
    }
    onActivation == null ? void 0 : onActivation({
      event: event
    });
    return true;
  }
}];
var events$1 = {
  move: {
    name: 'mousemove'
  },
  end: {
    name: 'mouseup'
  }
};
var MouseButton;
(function (MouseButton) {
  MouseButton[MouseButton["RightClick"] = 2] = "RightClick";
})(MouseButton || (MouseButton = {}));
var MouseSensor = /*#__PURE__*/function (_AbstractPointerSenso2) {
  function MouseSensor(props) {
    _classCallCheck(this, MouseSensor);
    return _callSuper(this, MouseSensor, [props, events$1, getOwnerDocument(props.event.target)]);
  }
  _inherits(MouseSensor, _AbstractPointerSenso2);
  return _createClass(MouseSensor);
}(AbstractPointerSensor);
MouseSensor.activators = [{
  eventName: 'onMouseDown',
  handler: function handler(_ref24, _ref25) {
    var event = _ref24.nativeEvent;
    var onActivation = _ref25.onActivation;
    if (event.button === MouseButton.RightClick) {
      return false;
    }
    onActivation == null ? void 0 : onActivation({
      event: event
    });
    return true;
  }
}];
var events$2 = {
  move: {
    name: 'touchmove'
  },
  end: {
    name: 'touchend'
  }
};
var TouchSensor = /*#__PURE__*/function (_AbstractPointerSenso3) {
  function TouchSensor(props) {
    _classCallCheck(this, TouchSensor);
    return _callSuper(this, TouchSensor, [props, events$2]);
  }
  _inherits(TouchSensor, _AbstractPointerSenso3);
  return _createClass(TouchSensor);
}(AbstractPointerSensor);
TouchSensor.activators = [{
  eventName: 'onTouchStart',
  handler: function handler(_ref26, _ref27) {
    var event = _ref26.nativeEvent;
    var onActivation = _ref27.onActivation;
    var touches = event.touches;
    if (touches.length > 1) {
      return false;
    }
    onActivation == null ? void 0 : onActivation({
      event: event
    });
    return true;
  }
}];
function applyModifiers(modifiers, _ref28) {
  var transform = _ref28.transform,
    args = _objectWithoutProperties(_ref28, _excluded);
  return (modifiers == null ? void 0 : modifiers.length) ? modifiers.reduce(function (accumulator, modifier) {
    return modifier(_objectSpread({
      transform: accumulator
    }, args));
  }, transform) : transform;
}
var defaultSensors = [{
  sensor: PointerSensor,
  options: {}
}, {
  sensor: KeyboardSensor,
  options: {}
}];
var defaultData = {
  current: {}
};
var ActiveDraggableContext = /*#__PURE__*/createContext(_objectSpread(_objectSpread({}, defaultCoordinates), {}, {
  scaleX: 1,
  scaleY: 1
}));
var DndContext = /*#__PURE__*/memo(function DndContext(_ref29) {
  var id = _ref29.id,
    _ref29$autoScroll = _ref29.autoScroll,
    autoScroll = _ref29$autoScroll === void 0 ? true : _ref29$autoScroll,
    announcements = _ref29.announcements,
    children = _ref29.children,
    _ref29$sensors = _ref29.sensors,
    sensors = _ref29$sensors === void 0 ? defaultSensors : _ref29$sensors,
    _ref29$collisionDetec = _ref29.collisionDetection,
    collisionDetection = _ref29$collisionDetec === void 0 ? rectIntersection : _ref29$collisionDetec,
    layoutMeasuring = _ref29.layoutMeasuring,
    modifiers = _ref29.modifiers,
    _ref29$screenReaderIn = _ref29.screenReaderInstructions,
    screenReaderInstructions$1 = _ref29$screenReaderIn === void 0 ? screenReaderInstructions : _ref29$screenReaderIn,
    props = _objectWithoutProperties(_ref29, _excluded2);
  var _sensorContext$curren, _sensorContext$curren2, _overContainer$rect$c;
  var store = useReducer(reducer, undefined, getInitialState);
  var _store = _slicedToArray(store, 2),
    state = _store[0],
    dispatch = _store[1];
  var _useState7 = useState(function () {
      return {
        type: null,
        event: null
      };
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    monitorState = _useState8[0],
    setMonitorState = _useState8[1];
  var _state$draggable = state.draggable,
    activeId = _state$draggable.active,
    draggableNodes = _state$draggable.nodes,
    translate = _state$draggable.translate,
    droppableContainers = state.droppable.containers;
  var node = activeId ? draggableNodes[activeId] : null;
  var activeRects = useRef({
    initial: null,
    translated: null
  });
  var active = useMemo(function () {
    var _node$data;
    return activeId != null ? {
      id: activeId,
      // It's possible for the active node to unmount while dragging
      data: (_node$data = node == null ? void 0 : node.data) != null ? _node$data : defaultData,
      rect: activeRects
    } : null;
  }, [activeId, node]);
  var activeRef = useRef(null);
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    activeSensor = _useState10[0],
    setActiveSensor = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    activatorEvent = _useState12[0],
    setActivatorEvent = _useState12[1];
  var latestProps = useRef(props);
  var draggableDescribedById = useUniqueId("DndDescribedBy", id);
  var _useLayoutMeasuring = useLayoutMeasuring(droppableContainers, {
      dragging: activeId != null,
      dependencies: [translate.x, translate.y],
      config: layoutMeasuring
    }),
    droppableRects = _useLayoutMeasuring.layoutRectMap,
    recomputeLayouts = _useLayoutMeasuring.recomputeLayouts,
    willRecomputeLayouts = _useLayoutMeasuring.willRecomputeLayouts;
  var activeNode = useCachedNode(draggableNodes, activeId);
  var activationCoordinates = activatorEvent ? getEventCoordinates(activatorEvent) : null;
  var activeNodeRect = useViewRect(activeNode);
  var activeNodeClientRect = useClientRect(activeNode);
  var initialActiveNodeRectRef = useRef(null);
  var initialActiveNodeRect = initialActiveNodeRectRef.current;
  var nodeRectDelta = getRectDelta(activeNodeRect, initialActiveNodeRect);
  var sensorContext = useRef({
    active: null,
    activeNode: activeNode,
    collisionRect: null,
    droppableRects: droppableRects,
    draggableNodes: draggableNodes,
    draggingNodeRect: null,
    droppableContainers: droppableContainers,
    over: null,
    scrollableAncestors: [],
    scrollAdjustedTranslate: null,
    translatedRect: null
  });
  var overNode = getDroppableNode((_sensorContext$curren = (_sensorContext$curren2 = sensorContext.current.over) == null ? void 0 : _sensorContext$curren2.id) != null ? _sensorContext$curren : null, droppableContainers);
  var windowRect = useClientRect(activeNode ? activeNode.ownerDocument.defaultView : null);
  var containerNodeRect = useClientRect(activeNode ? activeNode.parentElement : null);
  var scrollableAncestors = useScrollableAncestors(activeId ? overNode != null ? overNode : activeNode : null);
  var scrollableAncestorRects = useClientRects(scrollableAncestors);
  var _useNodeRef = useNodeRef(),
    _useNodeRef2 = _slicedToArray(_useNodeRef, 2),
    overlayNodeRef = _useNodeRef2[0],
    setOverlayNodeRef = _useNodeRef2[1];
  var overlayNodeRect = useClientRect(activeId ? overlayNodeRef.current : null, willRecomputeLayouts);
  var draggingNodeRect = overlayNodeRect != null ? overlayNodeRect : activeNodeClientRect;
  var modifiedTranslate = applyModifiers(modifiers, {
    transform: {
      x: translate.x - nodeRectDelta.x,
      y: translate.y - nodeRectDelta.y,
      scaleX: 1,
      scaleY: 1
    },
    active: active,
    over: sensorContext.current.over,
    activeNodeRect: activeNodeClientRect,
    draggingNodeRect: draggingNodeRect,
    containerNodeRect: containerNodeRect,
    overlayNodeRect: overlayNodeRect,
    scrollableAncestors: scrollableAncestors,
    scrollableAncestorRects: scrollableAncestorRects,
    windowRect: windowRect
  });
  var pointerCoordinates = activationCoordinates ? add(activationCoordinates, translate) : null;
  var scrollAdjustment = useScrollOffsets(scrollableAncestors);
  var scrollAdjustedTranslate = add(modifiedTranslate, scrollAdjustment);
  var translatedRect = activeNodeRect ? getAdjustedRect(activeNodeRect, modifiedTranslate) : null;
  var collisionRect = translatedRect ? getAdjustedRect(translatedRect, scrollAdjustment) : null;
  var overId = active && collisionRect ? collisionDetection(Array.from(droppableRects.entries()), collisionRect) : null;
  var overContainer = getOver(overId, droppableContainers);
  var over = useMemo(function () {
    return overContainer && overContainer.rect.current ? {
      id: overContainer.id,
      rect: overContainer.rect.current,
      data: overContainer.data,
      disabled: overContainer.disabled
    } : null;
  }, [overContainer]);
  var transform = adjustScale(modifiedTranslate, (_overContainer$rect$c = overContainer == null ? void 0 : overContainer.rect.current) != null ? _overContainer$rect$c : null, activeNodeRect);
  var instantiateSensor = useCallback(function (event, _ref30) {
    var Sensor = _ref30.sensor,
      options = _ref30.options;
    if (!activeRef.current) {
      return;
    }
    var activeNode = draggableNodes[activeRef.current];
    if (!activeNode) {
      return;
    }
    var sensorInstance = new Sensor({
      active: activeRef.current,
      activeNode: activeNode,
      event: event.nativeEvent,
      options: options,
      // Sensors need to be instantiated with refs for arguments that change over time
      // otherwise they are frozen in time with the stale arguments
      context: sensorContext,
      onStart: function onStart(initialCoordinates) {
        var id = activeRef.current;
        if (!id) {
          return;
        }
        var node = draggableNodes[id];
        if (!node) {
          return;
        }
        var onDragStart = latestProps.current.onDragStart;
        var event = {
          active: {
            id: id,
            data: node.data,
            rect: activeRects
          }
        };
        dispatch({
          type: Action.DragStart,
          initialCoordinates: initialCoordinates,
          active: id
        });
        setMonitorState({
          type: Action.DragStart,
          event: event
        });
        onDragStart == null ? void 0 : onDragStart(event);
      },
      onMove: function onMove(coordinates) {
        dispatch({
          type: Action.DragMove,
          coordinates: coordinates
        });
      },
      onEnd: createHandler(Action.DragEnd),
      onCancel: createHandler(Action.DragCancel)
    });
    setActiveSensor(sensorInstance);
    setActivatorEvent(event.nativeEvent);
    function createHandler(type) {
      return /*#__PURE__*/function () {
        var _handler = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var _sensorContext$curren3, active, over, scrollAdjustedTranslate, event, cancelDrop, shouldCancel, _latestProps$current, onDragCancel, onDragEnd, _handler2;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _sensorContext$curren3 = sensorContext.current, active = _sensorContext$curren3.active, over = _sensorContext$curren3.over, scrollAdjustedTranslate = _sensorContext$curren3.scrollAdjustedTranslate;
                event = null;
                if (!(active && scrollAdjustedTranslate)) {
                  _context.next = 10;
                  break;
                }
                cancelDrop = latestProps.current.cancelDrop;
                event = {
                  active: active,
                  delta: scrollAdjustedTranslate,
                  over: over
                };
                if (!(type === Action.DragEnd && typeof cancelDrop === 'function')) {
                  _context.next = 10;
                  break;
                }
                _context.next = 8;
                return Promise.resolve(cancelDrop(event));
              case 8:
                shouldCancel = _context.sent;
                if (shouldCancel) {
                  type = Action.DragCancel;
                }
              case 10:
                activeRef.current = null;
                dispatch({
                  type: type
                });
                setActiveSensor(null);
                setActivatorEvent(null);
                if (event) {
                  _latestProps$current = latestProps.current, onDragCancel = _latestProps$current.onDragCancel, onDragEnd = _latestProps$current.onDragEnd;
                  _handler2 = type === Action.DragEnd ? onDragEnd : onDragCancel;
                  setMonitorState({
                    type: type,
                    event: event
                  });
                  _handler2 == null ? void 0 : _handler2(event);
                }
              case 15:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function handler() {
          return _handler.apply(this, arguments);
        }
        return handler;
      }();
    }
  }, [dispatch, draggableNodes]);
  var bindActivatorToSensorInstantiator = useCallback(function (handler, sensor) {
    return function (event, active) {
      var nativeEvent = event.nativeEvent;
      if (
      // No active draggable
      activeRef.current !== null ||
      // Event has already been captured
      nativeEvent.dndKit || nativeEvent.defaultPrevented) {
        return;
      }
      if (handler(event, sensor.options) === true) {
        nativeEvent.dndKit = {
          capturedBy: sensor.sensor
        };
        activeRef.current = active;
        instantiateSensor(event, sensor);
      }
    };
  }, [instantiateSensor]);
  var activators = useCombineActivators(sensors, bindActivatorToSensorInstantiator);
  useIsomorphicLayoutEffect(function () {
    latestProps.current = props;
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Object.values(props));
  useEffect(function () {
    if (!active) {
      initialActiveNodeRectRef.current = null;
    }
    if (active && activeNodeRect && !initialActiveNodeRectRef.current) {
      initialActiveNodeRectRef.current = activeNodeRect;
    }
  }, [activeNodeRect, active]);
  useEffect(function () {
    var onDragMove = latestProps.current.onDragMove;
    var _sensorContext$curren4 = sensorContext.current,
      active = _sensorContext$curren4.active,
      over = _sensorContext$curren4.over;
    if (!active) {
      return;
    }
    var event = {
      active: active,
      delta: {
        x: scrollAdjustedTranslate.x,
        y: scrollAdjustedTranslate.y
      },
      over: over
    };
    setMonitorState({
      type: Action.DragMove,
      event: event
    });
    onDragMove == null ? void 0 : onDragMove(event);
  }, [scrollAdjustedTranslate.x, scrollAdjustedTranslate.y]);
  useEffect(function () {
    var _sensorContext$curren5 = sensorContext.current,
      active = _sensorContext$curren5.active,
      scrollAdjustedTranslate = _sensorContext$curren5.scrollAdjustedTranslate;
    if (!active || !activeRef.current || !scrollAdjustedTranslate) {
      return;
    }
    var onDragOver = latestProps.current.onDragOver;
    var event = {
      active: active,
      delta: {
        x: scrollAdjustedTranslate.x,
        y: scrollAdjustedTranslate.y
      },
      over: over
    };
    setMonitorState({
      type: Action.DragOver,
      event: event
    });
    onDragOver == null ? void 0 : onDragOver(event);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [over == null ? void 0 : over.id]);
  useIsomorphicLayoutEffect(function () {
    sensorContext.current = {
      active: active,
      activeNode: activeNode,
      collisionRect: collisionRect,
      droppableRects: droppableRects,
      draggableNodes: draggableNodes,
      draggingNodeRect: draggingNodeRect,
      droppableContainers: droppableContainers,
      over: over,
      scrollableAncestors: scrollableAncestors,
      scrollAdjustedTranslate: scrollAdjustedTranslate,
      translatedRect: translatedRect
    };
    activeRects.current = {
      initial: draggingNodeRect,
      translated: translatedRect
    };
  }, [active, activeNode, collisionRect, draggableNodes, draggingNodeRect, droppableRects, droppableContainers, over, scrollableAncestors, scrollAdjustedTranslate, translatedRect]);
  useAutoScroller(_objectSpread(_objectSpread({}, getAutoScrollerOptions()), {}, {
    draggingRect: translatedRect,
    pointerCoordinates: pointerCoordinates,
    scrollableAncestors: scrollableAncestors,
    scrollableAncestorRects: scrollableAncestorRects
  }));
  var contextValue = useMemo(function () {
    var memoizedContext = {
      active: active,
      activeNode: activeNode,
      activeNodeRect: activeNodeRect,
      activeNodeClientRect: activeNodeClientRect,
      activatorEvent: activatorEvent,
      activators: activators,
      ariaDescribedById: {
        draggable: draggableDescribedById
      },
      overlayNode: {
        nodeRef: overlayNodeRef,
        rect: overlayNodeRect,
        setRef: setOverlayNodeRef
      },
      containerNodeRect: containerNodeRect,
      dispatch: dispatch,
      draggableNodes: draggableNodes,
      droppableContainers: droppableContainers,
      droppableRects: droppableRects,
      over: over,
      recomputeLayouts: recomputeLayouts,
      scrollableAncestors: scrollableAncestors,
      scrollableAncestorRects: scrollableAncestorRects,
      willRecomputeLayouts: willRecomputeLayouts,
      windowRect: windowRect
    };
    return memoizedContext;
  }, [active, activeNode, activeNodeClientRect, activeNodeRect, activatorEvent, activators, containerNodeRect, overlayNodeRect, overlayNodeRef, dispatch, draggableNodes, draggableDescribedById, droppableContainers, droppableRects, over, recomputeLayouts, scrollableAncestors, scrollableAncestorRects, setOverlayNodeRef, willRecomputeLayouts, windowRect]);
  return /*#__PURE__*/React.createElement(DndMonitorContext.Provider, {
    value: monitorState
  }, /*#__PURE__*/React.createElement(Context.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(ActiveDraggableContext.Provider, {
    value: transform
  }, children)), /*#__PURE__*/React.createElement(Accessibility, {
    announcements: announcements,
    hiddenTextDescribedById: draggableDescribedById,
    screenReaderInstructions: screenReaderInstructions$1
  }));
  function getAutoScrollerOptions() {
    var activeSensorDisablesAutoscroll = (activeSensor == null ? void 0 : activeSensor.autoScrollEnabled) === false;
    var autoScrollGloballyDisabled = _typeof(autoScroll) === 'object' ? autoScroll.enabled === false : autoScroll === false;
    var enabled = !activeSensorDisablesAutoscroll && !autoScrollGloballyDisabled;
    if (_typeof(autoScroll) === 'object') {
      return _objectSpread(_objectSpread({}, autoScroll), {}, {
        enabled: enabled
      });
    }
    return {
      enabled: enabled
    };
  }
});
function getDroppableNode(id, droppableContainers) {
  var _droppableContainers$, _droppableContainers$2;
  return id ? (_droppableContainers$ = (_droppableContainers$2 = droppableContainers[id]) == null ? void 0 : _droppableContainers$2.node.current) != null ? _droppableContainers$ : null : null;
}
function getOver(id, droppableContainers) {
  var _droppableContainers$3;
  return id ? (_droppableContainers$3 = droppableContainers[id]) != null ? _droppableContainers$3 : null : null;
}
var NullContext = /*#__PURE__*/createContext(null);
var defaultRole = 'button';
function useDraggable(_ref31) {
  var id = _ref31.id,
    data = _ref31.data,
    _ref31$disabled = _ref31.disabled,
    disabled = _ref31$disabled === void 0 ? false : _ref31$disabled,
    attributes = _ref31.attributes;
  var _useContext = useContext(Context),
    active = _useContext.active,
    activeNodeRect = _useContext.activeNodeRect,
    activatorEvent = _useContext.activatorEvent,
    ariaDescribedById = _useContext.ariaDescribedById,
    draggableNodes = _useContext.draggableNodes,
    droppableRects = _useContext.droppableRects,
    activators = _useContext.activators,
    over = _useContext.over;
  var _ref32 = attributes != null ? attributes : {},
    _ref32$role = _ref32.role,
    role = _ref32$role === void 0 ? defaultRole : _ref32$role,
    _ref32$roleDescriptio = _ref32.roleDescription,
    roleDescription = _ref32$roleDescriptio === void 0 ? 'draggable' : _ref32$roleDescriptio,
    _ref32$tabIndex = _ref32.tabIndex,
    tabIndex = _ref32$tabIndex === void 0 ? 0 : _ref32$tabIndex;
  var isDragging = (active == null ? void 0 : active.id) === id;
  var transform = useContext(isDragging ? ActiveDraggableContext : NullContext);
  var _useNodeRef3 = useNodeRef(),
    _useNodeRef4 = _slicedToArray(_useNodeRef3, 2),
    node = _useNodeRef4[0],
    setNodeRef = _useNodeRef4[1];
  var listeners = useSyntheticListeners(activators, id);
  var dataRef = useData(data);
  useEffect(function () {
    draggableNodes[id] = {
      node: node,
      data: dataRef
    };
    return function () {
      delete draggableNodes[id];
    };
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [draggableNodes, id]);
  var memoizedAttributes = useMemo(function () {
    return {
      role: role,
      tabIndex: tabIndex,
      'aria-pressed': isDragging && role === defaultRole ? true : undefined,
      'aria-roledescription': roleDescription,
      'aria-describedby': ariaDescribedById.draggable
    };
  }, [role, tabIndex, isDragging, roleDescription, ariaDescribedById.draggable]);
  return {
    active: active,
    activeNodeRect: activeNodeRect,
    activatorEvent: activatorEvent,
    attributes: memoizedAttributes,
    droppableRects: droppableRects,
    isDragging: isDragging,
    listeners: disabled ? undefined : listeners,
    node: node,
    over: over,
    setNodeRef: setNodeRef,
    transform: transform
  };
}
function useDndContext() {
  return useContext(Context);
}
function useDroppable(_ref33) {
  var data = _ref33.data,
    _ref33$disabled = _ref33.disabled,
    disabled = _ref33$disabled === void 0 ? false : _ref33$disabled,
    id = _ref33.id;
  var _useContext2 = useContext(Context),
    active = _useContext2.active,
    dispatch = _useContext2.dispatch,
    over = _useContext2.over;
  var rect = useRef(null);
  var _useNodeRef5 = useNodeRef(),
    _useNodeRef6 = _slicedToArray(_useNodeRef5, 2),
    nodeRef = _useNodeRef6[0],
    setNodeRef = _useNodeRef6[1];
  var dataRef = useData(data);
  useIsomorphicLayoutEffect(function () {
    dispatch({
      type: Action.RegisterDroppable,
      element: {
        id: id,
        disabled: disabled,
        node: nodeRef,
        rect: rect,
        data: dataRef
      }
    });
    return function () {
      return dispatch({
        type: Action.UnregisterDroppable,
        id: id
      });
    };
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [id]);
  useEffect(function () {
    dispatch({
      type: Action.SetDroppableDisabled,
      id: id,
      disabled: disabled
    });
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [disabled]);
  return {
    active: active,
    rect: rect,
    isOver: (over == null ? void 0 : over.id) === id,
    node: nodeRef,
    over: over,
    setNodeRef: setNodeRef
  };
}
function useDerivedTransform(transform, rect, overlayNode) {
  var prevRect = useRef(rect);
  return useLazyMemo(function (previousValue) {
    var initial = prevRect.current;
    if (rect !== initial) {
      if (rect && initial) {
        var layoutHasChanged = initial.left !== rect.left || initial.top !== rect.top;
        if (layoutHasChanged && !previousValue) {
          var overlayNodeRect = overlayNode == null ? void 0 : overlayNode.getBoundingClientRect();
          if (overlayNodeRect) {
            var delta = _objectSpread(_objectSpread({}, transform), {}, {
              x: overlayNodeRect.left - rect.left,
              y: overlayNodeRect.top - rect.top
            });
            return delta;
          }
        }
      }
      prevRect.current = rect;
    }
    return undefined;
  }, [rect, transform, overlayNode]);
}
function useDropAnimation(_ref34) {
  var animate = _ref34.animate,
    adjustScale = _ref34.adjustScale,
    activeId = _ref34.activeId,
    draggableNodes = _ref34.draggableNodes,
    duration = _ref34.duration,
    easing = _ref34.easing,
    dragSourceOpacity = _ref34.dragSourceOpacity,
    node = _ref34.node,
    transform = _ref34.transform;
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    dropAnimationComplete = _useState14[0],
    setDropAnimationComplete = _useState14[1];
  useEffect(function () {
    if (!animate || !activeId || !easing || !duration) {
      if (animate) {
        setDropAnimationComplete(true);
      }
      return;
    }
    requestAnimationFrame(function () {
      var _draggableNodes$activ;
      var finalNode = (_draggableNodes$activ = draggableNodes[activeId]) == null ? void 0 : _draggableNodes$activ.node.current;
      if (transform && node && finalNode && finalNode.parentNode !== null) {
        var fromNode = node.children.length > 1 ? node : node.children[0];
        if (fromNode) {
          var from = fromNode.getBoundingClientRect();
          var to = getViewRect(finalNode);
          var delta = {
            x: from.left - to.left,
            y: from.top - to.top
          };
          if (Math.abs(delta.x) || Math.abs(delta.y)) {
            var scaleDelta = {
              scaleX: adjustScale ? to.width * transform.scaleX / from.width : 1,
              scaleY: adjustScale ? to.height * transform.scaleY / from.height : 1
            };
            var finalTransform = CSS.Transform.toString(_objectSpread({
              x: transform.x - delta.x,
              y: transform.y - delta.y
            }, scaleDelta));
            var originalOpacity = finalNode.style.opacity;
            if (dragSourceOpacity != null) {
              finalNode.style.opacity = "".concat(dragSourceOpacity);
            }
            var nodeAnimation = node.animate([{
              transform: CSS.Transform.toString(transform)
            }, {
              transform: finalTransform
            }], {
              easing: easing,
              duration: duration
            });
            nodeAnimation.onfinish = function () {
              node.style.display = 'none';
              setDropAnimationComplete(true);
              if (finalNode && dragSourceOpacity != null) {
                finalNode.style.opacity = originalOpacity;
              }
            };
            return;
          }
        }
      }
      setDropAnimationComplete(true);
    });
  }, [animate, activeId, adjustScale, draggableNodes, duration, easing, dragSourceOpacity, node, transform]);
  useIsomorphicLayoutEffect(function () {
    if (dropAnimationComplete) {
      setDropAnimationComplete(false);
    }
  }, [dropAnimationComplete]);
  return dropAnimationComplete;
}
var defaultTransition = function defaultTransition(activatorEvent) {
  var isKeyboardActivator = activatorEvent instanceof KeyboardEvent;
  return isKeyboardActivator ? 'transform 250ms ease' : undefined;
};
var defaultDropAnimation = {
  duration: 250,
  easing: 'ease',
  dragSourceOpacity: 0
};
var DragOverlay = /*#__PURE__*/React.memo(function (_ref35) {
  var _ref35$adjustScale = _ref35.adjustScale,
    adjustScale = _ref35$adjustScale === void 0 ? false : _ref35$adjustScale,
    children = _ref35.children,
    _ref35$dropAnimation = _ref35.dropAnimation,
    dropAnimation = _ref35$dropAnimation === void 0 ? defaultDropAnimation : _ref35$dropAnimation,
    styleProp = _ref35.style,
    _ref35$transition = _ref35.transition,
    transition = _ref35$transition === void 0 ? defaultTransition : _ref35$transition,
    modifiers = _ref35.modifiers,
    _ref35$wrapperElement = _ref35.wrapperElement,
    wrapperElement = _ref35$wrapperElement === void 0 ? 'div' : _ref35$wrapperElement,
    className = _ref35.className,
    _ref35$zIndex = _ref35.zIndex,
    zIndex = _ref35$zIndex === void 0 ? 999 : _ref35$zIndex;
  var _active$id, _attributesSnapshot$c;
  var _useDndContext = useDndContext(),
    active = _useDndContext.active,
    activeNodeRect = _useDndContext.activeNodeRect,
    activeNodeClientRect = _useDndContext.activeNodeClientRect,
    containerNodeRect = _useDndContext.containerNodeRect,
    draggableNodes = _useDndContext.draggableNodes,
    activatorEvent = _useDndContext.activatorEvent,
    over = _useDndContext.over,
    overlayNode = _useDndContext.overlayNode,
    scrollableAncestors = _useDndContext.scrollableAncestors,
    scrollableAncestorRects = _useDndContext.scrollableAncestorRects,
    windowRect = _useDndContext.windowRect;
  var transform = useContext(ActiveDraggableContext);
  var modifiedTransform = applyModifiers(modifiers, {
    active: active,
    activeNodeRect: activeNodeClientRect,
    draggingNodeRect: overlayNode.rect,
    containerNodeRect: containerNodeRect,
    over: over,
    overlayNodeRect: overlayNode.rect,
    scrollableAncestors: scrollableAncestors,
    scrollableAncestorRects: scrollableAncestorRects,
    transform: transform,
    windowRect: windowRect
  });
  var derivedTransform = useDerivedTransform(modifiedTransform, activeNodeRect, overlayNode.nodeRef.current);
  var isDragging = active !== null;
  var intermediateTransform = derivedTransform != null ? derivedTransform : modifiedTransform;
  var finalTransform = adjustScale ? intermediateTransform : _objectSpread(_objectSpread({}, intermediateTransform), {}, {
    scaleX: 1,
    scaleY: 1
  });
  var style = activeNodeRect ? _objectSpread({
    position: 'fixed',
    width: activeNodeRect.width,
    height: activeNodeRect.height,
    top: activeNodeRect.top,
    left: activeNodeRect.left,
    zIndex: zIndex,
    transform: CSS.Transform.toString(finalTransform),
    touchAction: 'none',
    transformOrigin: adjustScale && activatorEvent ? getRelativeTransformOrigin(activatorEvent, activeNodeRect) : undefined,
    transition: derivedTransform ? undefined : typeof transition === 'function' ? transition(activatorEvent) : transition
  }, styleProp) : undefined;
  var attributes = isDragging ? {
    style: style,
    children: children,
    className: className,
    transform: finalTransform
  } : undefined;
  var attributesSnapshot = useRef(attributes);
  var derivedAttributes = attributes != null ? attributes : attributesSnapshot.current;
  var _ref36 = derivedAttributes != null ? derivedAttributes : {},
    finalChildren = _ref36.children,
    _ = _ref36.transform,
    otherAttributes = _objectWithoutProperties(_ref36, _excluded3);
  var prevActiveId = useRef((_active$id = active == null ? void 0 : active.id) != null ? _active$id : null);
  var dropAnimationComplete = useDropAnimation({
    animate: Boolean(dropAnimation && prevActiveId.current && !active),
    adjustScale: adjustScale,
    activeId: prevActiveId.current,
    draggableNodes: draggableNodes,
    duration: dropAnimation == null ? void 0 : dropAnimation.duration,
    easing: dropAnimation == null ? void 0 : dropAnimation.easing,
    dragSourceOpacity: dropAnimation == null ? void 0 : dropAnimation.dragSourceOpacity,
    node: overlayNode.nodeRef.current,
    transform: (_attributesSnapshot$c = attributesSnapshot.current) == null ? void 0 : _attributesSnapshot$c.transform
  });
  var shouldRender = Boolean(finalChildren && (children || dropAnimation && !dropAnimationComplete));
  useEffect(function () {
    if ((active == null ? void 0 : active.id) !== prevActiveId.current) {
      var _active$id2;
      prevActiveId.current = (_active$id2 = active == null ? void 0 : active.id) != null ? _active$id2 : null;
    }
    if (active && attributesSnapshot.current !== attributes) {
      attributesSnapshot.current = attributes;
    }
  }, [active, attributes]);
  useEffect(function () {
    if (dropAnimationComplete) {
      attributesSnapshot.current = undefined;
    }
  }, [dropAnimationComplete]);
  if (!shouldRender) {
    return null;
  }
  return /*#__PURE__*/React.createElement(wrapperElement, _objectSpread(_objectSpread({}, otherAttributes), {}, {
    ref: overlayNode.setRef
  }), finalChildren);
});
export { AutoScrollActivator, DndContext, DragOverlay, KeyboardCode, KeyboardSensor, LayoutMeasuringFrequency, LayoutMeasuringStrategy, MouseSensor, PointerSensor, TouchSensor, TraversalOrder, applyModifiers, closestCenter, closestCorners, defaultAnnouncements, defaultCoordinates, defaultDropAnimation, getBoundingClientRect, getScrollableAncestors, getViewRect, rectIntersection, useDndContext, useDndMonitor, useDraggable, useDroppable, useSensor, useSensors };